module.exports = __webpack_public_path__ + "img/cancel.3e292075.png";